import React from 'react';
import Modal from './Modal';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const SessionExpiredModal = ({ isOpen, onClose }) => {
  const handleSignIn = async () => {
    try {
      const response = await fetch(`${API_BASE}/api/auth/google`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'get_auth_url' }),
      });
      const data = await response.json();
      if (data.auth_url) {
        window.location.href = data.auth_url;
      }
    } catch {
      window.location.reload();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} overlayClassName="session-expired-overlay">
      <div className="session-expired-modal">
        <div className="session-expired-header">
          <h2>Session expired</h2>
          <button className="modal-close-btn" onClick={onClose} aria-label="Dismiss">
            &#x2715;
          </button>
        </div>
        <p className="session-expired-body">
          Your session has expired or you are not logged in. Sign in again to continue.
        </p>
        <div className="session-expired-actions">
          <button className="session-expired-signin-btn" onClick={handleSignIn}>
            Sign in with Google
          </button>
          <button className="session-expired-dismiss-btn" onClick={onClose}>
            Dismiss
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SessionExpiredModal;
